import find from "lodash/find"
import get from "lodash/get"
import map from "lodash/map"
import isEmpty from "lodash/isEmpty"
import noop from "lodash/noop"
import { Link } from "component-lib/Base"
import {
  getAdobeLaunchAttribute,
  getAdobeLaunchClassName,
} from "utils-lib/analytics/launch"
import { updateClicksDL } from "utils-lib/analytics/dataLayer"
import { KEY_CODE_MAPPING } from "constants-lib/keyCodes"
import withRouter from "hoc-lib/router"
import { isTeamsitePage } from "utils-lib/isTeamsitePage"
import { isMyWMApp } from "utils-lib/isMyWMApp/index"
import { isNextApp } from "utils-lib/isNextApp"
import { getWindow } from "utils-lib/getWindow"
import HoverIntent from "hooks-lib/hoverIntent"

const ssrWindow = getWindow()

const greyBorder = `#d6d6d6`

const MegaNavSection = ({
  links,
  megaNavSubSelection,
  onMenuClick,
  megaNavSelection,
  setParentState,
  router,
  customFont = "",
  customClass = "",
  tabIndex = "0",
  ariaHidden = false,
}) => {
  if (isEmpty(links)) {
    return null
  }
  return (
    <div
      className="mb-3 mt-2"
      style={{
        borderLeft: `1px solid ${greyBorder}`,
        flexShrink: 0,
        marginTop: `1rem`,
      }}
    >
      {map(links, (section) => {
        const isSelected = section.secondLevelLinkTitle === megaNavSubSelection

        const clickLabel = section.secondLevelLinkTitle

        const analyticsClass = getAdobeLaunchClassName({ disabled: false })

        const linkProps = {
          ...getAdobeLaunchAttribute({
            value: clickLabel,
          }),
          className: `Header__section-link maax-font-weight-regular ${
            isSelected ? `wm-text-green` : `wm-text-gray-dark`
          } d-block py-2 pl-2 ${analyticsClass} ${customClass}`,
          tabIndex,
          "aria-hidden": ariaHidden,
        }
        /** we don't have jsons for L2.L3 pages in the master json ie en.model.json
         * so expect L1 page urls rest of all urls are need page reload to load respective json
         * from AEM server so L2,L3 like external urls need to place <a></a> in order
         * to avoid page flashes/flickering in L2/L3.
         *
         *In the below code just assigned isExternalLink = true by default to avoid many modifications.
         */
        const isExternalLink =
          isMyWMApp ||
          isTeamsitePage(ssrWindow.location.pathname) ||
          get(section, `isExternalLink`, true)

        linkProps.href = `${section.secondLevelLinkUrl}`
        linkProps.onClick = () => {
          updateClicksDL({
            ui_element: `MegaNavSectionLink`,
            object_name: ``,
            object_content: clickLabel,
          })

          if (!isExternalLink || !isNextApp) {
            onMenuClick(false)
          }
        }

        const content = (
          <div
            className={`d-flex align-items-center justify-content-between ${customFont}`}
          >
            {section.secondLevelLinkTitle}
            <div
              style={{
                marginRight: `.75rem`,
                width: 9,
              }}
            />
          </div>
        )

        // We don't need to worry about closing the meganav on selection for canada-app
        // because all links in canada-app should be external
        return (
          <div
            data-testid="MegaNavSection"
            key={section.secondLevelLinkTitle}
            style={{
              // background: isSelected ? `#f4f4f4` : `inherit`,
              cursor: `pointer`,
            }}
          >
            <HoverIntent
              onMouseOver={() =>
                setParentState({
                  megaNavSubSelection: section.secondLevelLinkTitle,
                })
              }
              onMouseOut={noop}
              sensitivity={20}
              interval={100}
            >
              <div>
                {isExternalLink ? (
                  <a
                    {...linkProps}
                    style={{
                      ...linkProps.style,
                      display: `block`,
                      width: `100%`,
                    }}
                    onKeyDown={(e) => {
                      /* handle spacebar event */
                      if (e.keyCode === KEY_CODE_MAPPING.SPACE_BAR) {
                        router.push(linkProps.href)
                        setParentState({
                          megaNavSelection: ``,
                        })
                      }
                    }}
                    data-testid="MegaNavSection-isExternalHyperLink"
                  >
                    {content}
                  </a>
                ) : (
                  <Link
                    {...linkProps}
                    overrideClass={linkProps.className}
                    onKeyDown={(e) => {
                      /* handle spacebar event */
                      if (e.keyCode === KEY_CODE_MAPPING.SPACE_BAR) {
                        router.push(linkProps.href)
                        setParentState({
                          megaNavSelection: ``,
                        })
                      }

                      if (e.keyCode === KEY_CODE_MAPPING.TAB && e.shiftKey) {
                        const isFirstItem =
                          ssrWindow.document.activeElement ===
                          ssrWindow.document.querySelector(
                            `#meganav-menu a:first-child`,
                          )

                        if (isFirstItem) {
                          e.preventDefault()

                          const menuItems = Array.from(
                            ssrWindow.document.querySelectorAll(
                              `.menu-item__text`,
                            ),
                          )

                          let itemIndex = 0
                          // eslint-disable-next-line consistent-return
                          find(menuItems, (item, i) => {
                            if (item.innerHTML === megaNavSelection) {
                              itemIndex = i

                              return true
                            }
                          })

                          const currentMenuItem =
                            ssrWindow.document.querySelector(
                              `.MenuItem:nth-child(${
                                itemIndex + 1
                              }) > .menu-item > button`,
                            )

                          currentMenuItem.focus()
                        }
                      }
                    }}
                  >
                    {content}
                  </Link>
                )}
              </div>
            </HoverIntent>
          </div>
        )
      })}
    </div>
  )
}

// // Note: React 19 no-longer supports propTypes. Leaving this for reference.
// MegaNavSectionLegacy.propTypes = {
//   links: PropTypes.array.isRequired,
//   megaNavSubSelection: PropTypes.string.isRequired,
//   onMenuClick: PropTypes.func.isRequired,
//   megaNavSelection: PropTypes.string.isRequired,
//   setParentState: PropTypes.func.isRequired,
//   router: PropTypes.object.isRequired,
//   customFont: PropTypes.string,
//   customClass: PropTypes.string,
//   tabIndex: PropTypes.string,
//   ariaHidden: PropTypes.bool,
// }

// // Note: React 19 no-longer supports defaultProps. Leaving this for reference.
// MegaNavSectionLegacy.defaultProps = {
//   customFont: "",
//   customClass: "",
//   tabIndex: "0",
//   ariaHidden: false,
// }

export default withRouter(MegaNavSection)
